export default "__VITE_ASSET__CxJIXI6n__"